module.exports = __webpack_public_path__ + "static/img/tablet-video-ela.6159ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/tablet-video-ela.png
// module id = 4ZK+
// module chunks = 1